import React from 'react';
import ControllerBase from './../../../../global/js/ControllerBase';
import { fromEvent } from 'rxjs';
import UIkit from 'uikit';
global ? (global['UIkit'] = UIkit) : undefined;

export default class ControllerAccordion extends ControllerBase {
	/** A list of dom element references available to this component */
	private readonly componentRefs = {
		switcherTrigger: 'switcherTrigger',
		switcherOutput: 'switcherOutput',
	};

	constructor(element: HTMLElement) {
		super(element);

		this.observeSwitchTrigger();
	}

	private observeSwitchTrigger(): void {
		const select = this.$references[this.componentRefs.switcherTrigger] as HTMLSelectElement;
		const output = this.$references[this.componentRefs.switcherOutput] as HTMLUListElement;

		select &&
			fromEvent(select, 'change').subscribe((s) => {
				let index = 0;

				const options = select.querySelectorAll('option:checked');
				if (options.length > 0) {
					const selectedOption = options[0] as HTMLOptionElement;
					index = Number(selectedOption.value);
				}

				UIkit.switcher(output).show(index);
			});
	}
}
